import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {config} from "../config";
import type {LoginRequest, LoginResponse} from "../types/auth";
import {logout, setCredentials} from "../feature/auth/authSlice";
import type {RootState} from "../app/store";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.apiBaseUrl,
    prepareHeaders: (headers, {getState}) => {
      const token = (getState() as RootState).auth.accessToken;
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (body) => ({
        url: "/auth/signIn",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, {dispatch, queryFulfilled}) {
        try {
          const {data} = await queryFulfilled;
          dispatch(setCredentials(data)); // <-- store tokens & user
        } catch {
          // optional: cleanup on failure
          dispatch(logout());
        }
      },
    }),
  }),
});

export const {useLoginMutation} = authApi;
